<div class="option">
    <input type="checkbox"
           [id]="id"
           [(ngModel)]="checked"
           (ngModelChange)="onChange($event)"
           class="option__input"
           [disabled]="disabled"
           />
    <label [for]="id" class="option__label">
        {{label}}
    </label>
</div>
<ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
